module.exports = __webpack_public_path__ + "static/news-events-2-382cc9855c1e4de841f9415a62e121a9.jpg";